<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { useRouter } from 'vue-router'

const router = useRouter()

const handleGetStarted = () => {
  router.push('/auth')
}
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <main
      class="flex-1 container mx-auto px-4 py-12 flex flex-col items-center justify-center gap-8"
    >
      <h1 class="text-4xl font-bold text-center">Welcome to Maximo</h1>

      <img
        src="/images/welcome-avatar.png"
        alt="Welcome"
        class="w-64 h-64 object-contain"
      />

      <div class="max-w-md w-full space-y-6">
        <p class="text-xl text-center text-gray-700">
          The easy way to take back your Tax and fund your Pension
        </p>

        <Button size="lg" class="w-full" @click="handleGetStarted">
          Get started
        </Button>
      </div>
    </main>
  </div>
</template>
